import { configureStore } from "@reduxjs/toolkit";
import occupationReducer from './occupationSlice';
import timeSlotReducer from './timeslotSlice';
import programCommercialReducer from './programmeCommercialSlice';
import coachReducer from './coachSlice';
import accountReducer from './accountSlice';
import accountGroupReducer from './accountGroupSlice';
import paymentmodeReducer from './paymentModeSlice';
import gstReducer from './gstSlice';
import otherItemsReducer from './otherItemSlice';
import holidayReducer from './holidaySlice'; 
import clubReducer from './clubSlice';
import tournamentReducer from './tournamentSlice';
import customerSlice from "./customerSlice";
import bankSlice from "./bankSlice";


const store = configureStore({
    reducer : {
        occupation : occupationReducer,
        timeslot : timeSlotReducer,
        programmeCommercial : programCommercialReducer,
        coach : coachReducer,
        account : accountReducer,
        accountgroup : accountGroupReducer,
        paymentmode : paymentmodeReducer,
        gst : gstReducer,
        otheritem : otherItemsReducer,
        holiday:holidayReducer,
        club:clubReducer,
        tournament:tournamentReducer,
        customer:customerSlice,
        bank:bankSlice
    }
});
export default store;